import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  API_REQUEST_STATUS_FAIL,
  API_REQUEST_STATUS_SUCCESS,
} from 'utils/static/constants';

const FreeEventRegistrationWhitelistMessage = () => {
  const { t } = useTranslation();
  return (
    <>
      <p className="title-xl">🕔</p>
      <div className="text-center">
        <p className="p1-bold mb-[8px]">
          {t('freeEventRegistrationPage.registrationPendingTextTitle')}
        </p>
        <p className="p2-medium max-w-[400px]">
          {t('freeEventRegistrationPage.registrationPendingTextSubtitle')}
        </p>
      </div>
    </>
  );
};

const FreeEventRegistrationSuccessMessage = ({
  confirmationText,
}: {
  confirmationText: string;
}) => {
  return (
    <>
      <p className="title-xl">✅</p>
      <p
        className="p2-medium max-w-[400px] text-center"
        dangerouslySetInnerHTML={{ __html: confirmationText }}
      ></p>
    </>
  );
};

const FreeEventRegistrationFailMessage = () => {
  const { t } = useTranslation();
  return (
    <>
      <p className="title-xl">❌</p>
      <p className="p1-medium">
        {t('freeEventRegistrationPage.registrationFailed')}
      </p>
    </>
  );
};

const FreeEventRegistrationFinalMessage: React.FC<{
  requestStatus: string;
  isWhitelisted: boolean;
  confirmationText: string;
}> = ({ requestStatus, isWhitelisted, confirmationText }) => {
  if (requestStatus === API_REQUEST_STATUS_SUCCESS && isWhitelisted)
    return <FreeEventRegistrationWhitelistMessage />;

  if (requestStatus === API_REQUEST_STATUS_SUCCESS)
    return (
      <FreeEventRegistrationSuccessMessage
        confirmationText={confirmationText}
      />
    );

  if (requestStatus === API_REQUEST_STATUS_FAIL)
    return <FreeEventRegistrationFailMessage />;

  return null;
};

export default FreeEventRegistrationFinalMessage;
